module.exports = __webpack_public_path__ + "static/media/logo-fb.c319e40c.png";